<template>
	<div class="flex justify-between">
		<CarbarCheckbox
			:name="_kebabCase(`${facetKey}-${facetItem.value}`)"
			:label="`${facetItem.label}`"
			:checked="isActiveFilter"
			@change="onChange(facetItem, $event)"
		>
			<template #label>
				<span class="text-gray-650">{{ facetItem.label }}</span>
			</template>
		</CarbarCheckbox>

		<div>
			<CarbarBadge
				background-color="bg-gray-160"
				text-color="text-gray-650"
				rounded="rounded"
			>
				{{ facetItem.count ? facetItem.count : 0 }}
			</CarbarBadge>
		</div>
	</div>
</template>

<script setup>
import { computed } from 'vue'
import { kebabCase as _kebabCase } from 'lodash-es'
import CarbarCheckbox from '@/components/checkboxes/CarbarCheckbox.vue'
import { useProductCatalog } from '@/stores/product-catalog'
import CarbarBadge from '@/components/badges/CarbarBadge.vue'

const productCatalog = useProductCatalog()

const props = defineProps({
	facetItem: {
		type: Object,
		required: true,
	},
	facetKey: {
		type: String,
		required: true,
	},
})

const emit = defineEmits(['change'])

const activeFilters = computed(() => productCatalog.activeFilters)

const isActiveFilter = computed(
	() =>
		activeFilters.value[props.facetKey] &&
		activeFilters.value[props.facetKey].includes(props.facetItem.value)
)

const onChange = (facetItem, event) => {
	productCatalog[event.target.checked ? 'updateFilter' : 'removeFilter']({
		filterKey: props.facetKey,
		filterValue: facetItem.value,
		overwrite: false,
	})

	emit('change', event)
}
</script>
